import React, { useEffect } from "react";
import FranchiseHero from "../components/franchise/FranchiseHero";
import FranchiseForm from "../components/franchise/FranchiseForm";

const FranchisePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <FranchiseHero />
      <FranchiseForm />
    </>
  );
};

export default FranchisePage;
